






import { Component, Vue } from "vue-property-decorator";
import AuditKeslingList from "@/components/kesling/audit/AuditKeslingList.vue";

@Component({
  components: { AuditKeslingList }
})
export default class AuditKeslingPage extends Vue {}
